import React from "react";
import PropTypes from "prop-types";

import "./FeedMainStat.scss";

import spaceint2 from "../../utils/spaceint2";

const FeedMainStat = ({ count, stat }) => (
  <div className="feed-main-stat">
    <span>Анонсов: {spaceint2(count)}</span>
    <span className="feed-main-stat__stat">{spaceint2(stat.clicks)}</span>
    <span className="feed-main-stat__stat">{spaceint2(stat.shows)}</span>
    <span className="feed-main-stat__stat">{stat.ctr}</span>
  </div>
);

FeedMainStat.propTypes = {
  stat: PropTypes.object.isRequired
};

export default FeedMainStat;
